// redux
import { Store } from 'redux/root';

export const selectorGetHashtags = (store: Store) => store.hashTagRedux.hashtags;
